import { render, staticRenderFns } from "./collegeset.vue?vue&type=template&id=6b4b84fc&scoped=true&"
import script from "./collegeset.vue?vue&type=script&lang=js&"
export * from "./collegeset.vue?vue&type=script&lang=js&"
import style0 from "./collegeset.vue?vue&type=style&index=0&id=6b4b84fc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4b84fc",
  null
  
)

export default component.exports